import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { NdtHubBase } from '../base/ndt-hub.base';
import { NdtHubConnectionService } from '../ndt-hub-connection.service';
import {
   promptCallDialBegin,
   promptCallHungUp,
   promptCallPickedUp,
   promptReady,
   recordingPrompt,
   reviewingPrompt,
   savingPrompt,
} from './recording-new-prompt-hub.actions';

@Injectable({ providedIn: 'root' })
export class RecordingNewPromptHub extends NdtHubBase {
   constructor(public ndtHubService: NdtHubConnectionService, private store: Store) {
      super(ndtHubService);
   }

   registerAsRecordingNewPrompt(sessionId: string): void {
      this.ndtHubService.connected.subscribe(() => {
         this.ndtHubService.connection.invoke('JoinRecordingNewPromptGroup', sessionId);
      });
   }

   unregisterRecordingNewPrompt(sessionId: string): void {
      this.ndtHubService.connected.subscribe(() => {
         this.ndtHubService.connection.invoke('LeaveRecordingNewPromptGroup', sessionId);
      });
   }

   wireUpHubEvents(): void {
      this.ndtHubService.connection.on('PromptReady', (promptId: string) => {
         const prompt = { promptId: parseInt(promptId) };
         this.store.dispatch(promptReady(prompt));
      });
      this.ndtHubService.connection.on('PromptCallDialBegin', (channelId: string, serverIp: string) => {
         this.store.dispatch(promptCallDialBegin({ channelId: channelId, serverIp: serverIp }));
      });
      this.ndtHubService.connection.on('PromptCallPickedUp', (channelId: string, serverIp: string) => {
         this.store.dispatch(promptCallPickedUp({ channelId: channelId, serverIp: serverIp }));
      });
      this.ndtHubService.connection.on('RecordingPrompt', () => {
         this.store.dispatch(recordingPrompt());
      });
      this.ndtHubService.connection.on('ReviewingPrompt', () => {
         this.store.dispatch(reviewingPrompt());
      });
      this.ndtHubService.connection.on('SavingPrompt', () => {
         this.store.dispatch(savingPrompt());
      });
      this.ndtHubService.connection.on('PromptCallHungUp', () => {
         this.store.dispatch(promptCallHungUp());
      });
   }
}
